module.exports = __webpack_public_path__ + "static/media/memoriesText.0100cb06.png";